require('../scss/_colorbox.scss');

(function ($) {
    $(function () {
      $(document).on("click", ".csn-theme.pre-approval-content a[data-toggle='lightbox']", function () {
        const $this = $(this);
        const url = $this.data("target-url");
        if (url === undefined || url === null || url === "") return;
        const isId = url.indexOf("#") === 0;
        const className = $this.data("lightbox-classname") ? $this.data("lightbox-classname") : false;
        const onClosed = $this.data("lightbox-onclosed") ? window[$this.data("lightbox-onclosed")] : false;
        const onComplete = $this.data("lightbox-onloaded") ? window[$this.data("lightbox-onloaded")] : false;
        const customData = $this.data("lightbox-custom-data") ? $this.data("lightbox-custom-data") : false;

        const config = {
          href: url,
          iframe: !isId,
          inline: isId,
          width: 635,
          height: 500,
          opacity: 0.95,
          fixed: true,
          reposition: true,
          className: className,
          onComplete: onComplete,
          onClosed: onClosed,
          fastIframe: false,
          customData: customData
        };

        if (config.iframe && $this.data("lightbox-fastIframe"))
          config.fastIframe = $this.data("lightbox-fastIframe") === "true";

        $.colorbox(config);
      });
    });
    
})(jQuery);
